/**
 * @generated SignedSource<<227f75f484773241c2aa9f6d9bb0d559>>
 * @relayHash be3ae060e2f957b2adfb254e6120448a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 54149d8226391da92fe5e768c4f208171509220a72b1dc7c3344710a49c8b746

import type { ConcreteRequest } from 'relay-runtime';
export type useConfluenceStandardToPremiumPUBTouchpointconfluenceEditionAwarenessQuery$variables = {
  cloudId: string;
  productKey: string;
  trialOfferingName: string;
};
export type useConfluenceStandardToPremiumPUBTouchpointconfluenceEditionAwarenessQuery$data = {
  readonly tenantContexts: ReadonlyArray<{
    readonly entitlementInfo: {
      readonly paidEntitlement: {
        readonly experienceCapabilities: {
          readonly changeOfferingV2: {
            readonly experienceUrl: string | null;
          } | null;
        } | null;
      } | null;
    } | null;
  } | null> | null;
};
export type useConfluenceStandardToPremiumPUBTouchpointconfluenceEditionAwarenessQuery = {
  response: useConfluenceStandardToPremiumPUBTouchpointconfluenceEditionAwarenessQuery$data;
  variables: useConfluenceStandardToPremiumPUBTouchpointconfluenceEditionAwarenessQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "productKey"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "trialOfferingName"
  }
],
v1 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "cloudIds.0",
        "variableName": "cloudId"
      }
    ],
    "kind": "ListValue",
    "name": "cloudIds"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "hamsProductKey",
    "variableName": "productKey"
  }
],
v3 = [
  {
    "kind": "Literal",
    "name": "where",
    "value": {
      "inTrialOrPreDunning": false
    }
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "offeringName",
    "variableName": "trialOfferingName"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "experienceUrl"
},
v6 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useConfluenceStandardToPremiumPUBTouchpointconfluenceEditionAwarenessQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              {
                "alias": "paidEntitlement",
                "args": (v3/*: any*/),
                "kind": "LinkedField",
                "name": "entitlement",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "experienceCapabilities",
                    "plural": false,
                    "selections": [
                      {
                        "args": (v4/*: any*/),
                        "kind": "LinkedField",
                        "name": "changeOfferingV2",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/)
                        ]
                      }
                    ]
                  }
                ],
                "storageKey": "entitlement(where:{\"inTrialOrPreDunning\":false})"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useConfluenceStandardToPremiumPUBTouchpointconfluenceEditionAwarenessQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "alias": "paidEntitlement",
                "args": (v3/*: any*/),
                "kind": "LinkedField",
                "name": "entitlement",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "experienceCapabilities",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "args": (v4/*: any*/),
                        "kind": "LinkedField",
                        "name": "changeOfferingV2",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v5/*: any*/)
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  }
                ],
                "storageKey": "entitlement(where:{\"inTrialOrPreDunning\":false})"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "be3ae060e2f957b2adfb254e6120448a",
    "id": "54149d8226391da92fe5e768c4f208171509220a72b1dc7c3344710a49c8b746",
    "metadata": {},
    "name": "useConfluenceStandardToPremiumPUBTouchpointconfluenceEditionAwarenessQuery",
    "operationKind": "query",
    "text": "query useConfluenceStandardToPremiumPUBTouchpointconfluenceEditionAwarenessQuery($cloudId:ID!,$productKey:String!,$trialOfferingName:String!){tenantContexts(cloudIds:[$cloudId])@optIn(to:[\"CcpAllUserUpgradeAndPay\",\"HamsAllUserUpgradeAndPay\"]){entitlementInfo(hamsProductKey:$productKey){__typename,paidEntitlement:entitlement(where:{inTrialOrPreDunning:false}){__typename,experienceCapabilities{__typename,changeOfferingV2(offeringName:$trialOfferingName){__typename,experienceUrl}},id}}}}"
  }
};
})();

(node as any).hash = "8dd9df30188856b8fcd47f1be57af4fa";

export default node;
